<template>
	<div>
		<b-form>
			<b-form-group id="exampleInputGroup1"
						  label="currentPassword:"
						  label-for="exampleInput1"
			>
				<b-form-input style="width: 30%" id="exampleInput1"
							  type="text"
							  v-model="payload.currentPassword"
							  required
							  placeholder="currentPassword">
				</b-form-input>
			</b-form-group>
			<b-form-group id="exampleInputGroup2"
						  label="newPassword:"
						  label-for="exampleInput2">
				<b-form-input style="width: 30%" id="exampleInput2"
							  type="password"
							  v-model="payload.newPassword"
							  required
							  placeholder="newPassword">
				</b-form-input>
			</b-form-group>
			<!--<h1>{{getSingeuser.password}}</h1>-->


			<b-button v-on:click.prevent="onUpdateById" type="submit" variant="primary">Submit</b-button>
			<!--<p>{{getSingeuser.username}}</p>-->
			<b-button type="reset" variant="danger">cancel</b-button>
		</b-form>

	</div>
</template>

<script>
	import {mapGetters, mapActions} from 'vuex';

	export default {
		data() {
			return {
				payload: {
					id: this.$route.params.id,
					currentPassword: '',
					newPassword: '',

				},
				title: "bekzod",
				selected: null,

			}


		},

		computed: {
			...mapGetters('users', [
				'getSingeuser'
			]),
		},


		methods: {

			...mapActions('users', [
				'getUserStoreById', 'updateUserBy'
			]),
			onUpdatsingleUsereById() {
				if (this.payload.currentPassword != '' && this.payload.newPassword != '') {

					this.updateUserBy(this.payload);
				} else {
				}

			}


		},
		created() {
			this.getUserStoreById(this.$route.params.id);
		},


	}
</script>
